"use strict";

var _toConsumableArray = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoamJsonQuery = void 0;

var _ = __importStar(require("lodash"));

var common_1 = require("./common");

var roam_utils_1 = require("./roam-utils");

var RoamJsonQuery = /*#__PURE__*/function () {
  function RoamJsonQuery(allPages, filter) {
    var _this = this;

    var createOrphansForBacklinks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    _classCallCheck(this, RoamJsonQuery);

    this.allPages = allPages;
    this.filter = filter;
    this.createOrphansForBacklinks = createOrphansForBacklinks;
    this.blockToPage = new Map();
    this.orphanId = 0;

    this.createOrphanPage = function (name) {
      var blocks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var _a;

      return {
        title: name,
        uid: ((_a = _this.pageByName.get(name)) === null || _a === void 0 ? void 0 : _a.uid) || "orphan-".concat(_this.orphanId++),
        children: [{
          string: "## This is an \"Orphan\" page. Its core content has not been shared: what you see below is a " + "loose collection of pages and page snippets that mention this page, as well as snippets of this " + "page that were quoted elsewhere.",
          uid: "orphan-".concat(_this.orphanId++)
        }].concat(_toConsumableArray(roam_utils_1.removeHierarchicalDuplicates(blocks)))
      };
    };

    this.removePrivateBlocks = function (pages) {
      return pages.map(function (page) {
        return roam_utils_1.removeChildMatching(page, _this.filter.makeBlocksWithTheseTagsPrivate);
      });
    };

    this.findPublicPages = function (pages) {
      if (_this.filter.makeAllPagesPublic) return pages;
      return pages.filter(function (it) {
        return _this.isPublic(it);
      });
    };

    this.isPublic = function (page) {
      var _a;

      return ((_a = _this.filter.pagesToMakePublic) === null || _a === void 0 ? void 0 : _a.includes(page.title)) || roam_utils_1.isPublic(page, _this.filter.makePagesWithTheseTagsPublic);
    };

    this.buildBlockToPageMap();
    this.pageByName = new Map(allPages.map(function (it) {
      return [it.title, it];
    }));
    this.pageByUid = new Map(allPages.map(function (it) {
      return [it.uid, it];
    }));
  }

  _createClass(RoamJsonQuery, [{
    key: "getPagesToRender",
    value: function getPagesToRender() {
      console.log("Starting filtering process with the following settings", this.filter);
      var pagesWithoutPrivateBlocks = this.removePrivateBlocks(this.allPages);
      var publicPages = this.findPublicPages(pagesWithoutPrivateBlocks);
      var referencedBlocks = roam_utils_1.getReferencedBlocks(publicPages, pagesWithoutPrivateBlocks);
      console.log("".concat(referencedBlocks.length, " blocks referenced by other blocks"));
      var pagesWithBlocks = [].concat(_toConsumableArray(publicPages), _toConsumableArray(this.createOrphanPagesWithBlocks(publicPages, referencedBlocks)));
      console.log("There is ".concat(pagesWithBlocks.length, " pages with blocks"));

      var _this$buildBlocksRefe = this.buildBlocksReferencingPages(pagesWithBlocks),
          blocksReferencingPages = _this$buildBlocksRefe.blocksReferencingPages,
          referencedPages = _this$buildBlocksRefe.referencedPages;

      var pagesToRender = this.createOrphansForBacklinks ? [].concat(_toConsumableArray(pagesWithBlocks), _toConsumableArray(this.createOrphansWithReferences(pagesWithBlocks, referencedPages))) : pagesWithBlocks;
      var blockUidsToRender = new Set([].concat(_toConsumableArray(referencedBlocks), _toConsumableArray(blocksReferencingPages)).map(function (it) {
        return it.uid;
      }));
      console.log("".concat(blockUidsToRender.size, " blocks to separately render"));
      return {
        pages: pagesToRender,
        blockUids: blockUidsToRender
      };
    }
  }, {
    key: "createOrphanPagesWithBlocks",
    value: function createOrphanPagesWithBlocks(publicPages, referencedBlocks) {
      var allPublicBlocks = new Set(roam_utils_1.getFlatBlockList(publicPages));
      var orphanBlocks = referencedBlocks.filter(function (it) {
        return !allPublicBlocks.has(it);
      });
      console.log("".concat(orphanBlocks.length + allPublicBlocks.size, " total blocks to make public"));
      return this.buildOrphanPages(orphanBlocks);
    }
  }, {
    key: "createOrphansWithReferences",
    value: function createOrphansWithReferences(pagesWithBlocks, referencedPages) {
      var _this2 = this;

      var existingTitles = new Set(pagesWithBlocks.map(function (it) {
        return it.title;
      }));

      var orphans = _toConsumableArray(referencedPages).filter(function (it) {
        return !existingTitles.has(it.title);
      });

      return orphans.map(function (it) {
        return _this2.createOrphanPage(it.title);
      });
    }
  }, {
    key: "buildOrphanPages",
    value: function buildOrphanPages(orphanBlocks) {
      var _this3 = this;

      var byPage = _.groupBy(orphanBlocks, function (it) {
        return _this3.blockToPage.get(it === null || it === void 0 ? void 0 : it.uid);
      });

      return _.keys(byPage).map(function (key) {
        return _this3.createOrphanPage(key, byPage[key]);
      });
    }
  }, {
    key: "buildBlockToPageMap",
    value: function buildBlockToPageMap() {
      var _this4 = this;

      this.allPages.forEach(function (it) {
        return roam_utils_1.visitChildren(it, function (block) {
          _this4.blockToPage.set(block["uid"], it.title);
        });
      });
    }
    /**
     * This is required to display content of the block in Backlinks/References section
     * Hence including the blocks that have references to any public pages
     * TODO: currently these are not rendered and only text is used, so can consider
     * not creating MDX nodes for these. Though would probably actually move to
     * using rendered version in the future
     */

  }, {
    key: "buildBlocksReferencingPages",
    value: function buildBlocksReferencingPages(pages) {
      var _this5 = this;

      var blocksReferencingPages = new Set();
      var referencedPages = new Set();
      pages.forEach(function (it) {
        return roam_utils_1.visitChildren(it, function (block) {
          var _a;

          if ("refs" in block) {
            var pagesInBlock = (_a = block.refs) === null || _a === void 0 ? void 0 : _a.map(function (ref) {
              return _this5.pageByUid.get(ref.uid);
            }).filter(common_1.truthy);
            if (pagesInBlock === null || pagesInBlock === void 0 ? void 0 : pagesInBlock.length) blocksReferencingPages.add(block);
            pagesInBlock === null || pagesInBlock === void 0 ? void 0 : pagesInBlock.forEach(function (page) {
              return referencedPages.add(page);
            });
          }
        });
      });
      return {
        blocksReferencingPages: blocksReferencingPages,
        referencedPages: referencedPages
      };
    }
  }]);

  return RoamJsonQuery;
}();

exports.RoamJsonQuery = RoamJsonQuery;